<template>
	<div class="ir-module-block">
		<CCalendar
			:value.sync="dateValue"
			:scheduleData="scheduleData"
			:styles="['circle-calendar']"
			@cell-click="handleCellClick"
		/>
		<div class="schedule-wrap">
			<CScheduleItem
				v-for="(item, index) in generateLimitedDisplayData(dateValue)"
				:key="index"
				:item="item"
				inline
			></CScheduleItem>
		</div>
		<slot name="footer"></slot>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import CCalendar from '@/view/enterprise/components/calendar/c-calendar.vue';
import CScheduleItem from '@/view/enterprise/components/calendar/c-schedule-item.vue';
import { getMonthRange } from '@/store/modules/calendar';
import useScheduleCache from './mixins/useScheduleCache';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { computed } from 'vue';
import { useCurrentContext } from './context';

export default {
	mixins: [useScheduleCache],
	components: {
		CCalendar,
		CScheduleItem
	},
	data() {
		return {
			dateValue: new Date(),
			scheduleData: []
		};
	},
	computed: {
		...mapGetters({
			'getIrBaseInfo': 'getIrBaseInfo'
		})
	},
	watch: {
		dateValue(val) {
			this.UPDATE_SCHEDULE_RENDER(val);
		}
	},
	mounted() {
		this.queryScheduleList(this.dateValue);

		const onScheduleUpdate = () => {
			this.queryScheduleList(this.dateValue);
		};
		this.REGISTER_ON_RENDER_UPDATE(onScheduleUpdate);
	},
	methods: {
		handleCellClick() {
			// 如果切换过其他的日期，后续展示的日程数据就以选中的日期为基准
		},
		async queryScheduleList(date) {
			const [rangeStart, rangeEnd] = getMonthRange(date);
			const _cache = []; // 覆盖缓存
			[
				this.$moment(date).format('YYYYMM'),
				this.$moment(rangeStart).format('YYYYMM'),
				this.$moment(rangeEnd).format('YYYYMM')
			].forEach(d => {
				_cache.push(d);
			});
			// 记录已经拿到数据的日期信息
			this.RESET_CACHED_SCHEDULE_MONTH_KEYS([...new Set(_cache)]);

			await this.loadScheduleList({
				startTime: rangeStart,
				endTime: rangeEnd
			});
			this.scheduleData = this.getScheduleList;
		},
		generateLimitedDisplayData(date) {
			return this.calenderCtx.generateLimitedDisplayData(this.scheduleData, date);
		},
		formatDateFn(data) {
			return this.calenderCtx.formatDateFn(data);
		}
	},
	setup() {
		const ctx = useCurrentContext();
		const { customs_calendar } = useModuleData();

		// 查询日程数据
		const loadScheduleList = async params => {
			await customs_calendar.refresh(params);
		};
		const getScheduleList = computed(() => customs_calendar.data?.data || []);

		return {
			calenderCtx: ctx,
			loadScheduleList,
			getScheduleList
		};
	}
};
</script>

<style lang="less" scoped>
.ir-module-block {
	margin-top: -0.16rem;
	margin-left: -0.12rem;
	margin-right: -0.12rem;
}
</style>
